var map = {
	"./de/general10/slide1.svg": 271200,
	"./en/general10/slide1.svg": 921828,
	"./es/general10/slide1.svg": 469335,
	"./fr/general10/slide1.svg": 485855,
	"./nl/general10/slide1.svg": 561573,
	"./pt/general10/slide1.svg": 646883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 901668;